import httpService from '@Utils/httpService';

const baseUrl = 'api/Companies';

export default {
 
  getById(id) {
    return httpService.get({
      url: `${baseUrl}/${id}`,
    });
  },
  update(data) {
    if (!data.id) return this.add(data);
    return httpService.put({
      url: `${baseUrl}/${data.id}`,
      data,
    });
  },complete(data, companyId) {
      return httpService.post({
        url: `${baseUrl}/${companyId}/Complete`,
        data,
      });
    },
 
};
